import { render, staticRenderFns } from "./verifyOtpModal.vue?vue&type=template&id=55960526&scoped=true&"
import script from "./verifyOtpModal.vue?vue&type=script&lang=js&"
export * from "./verifyOtpModal.vue?vue&type=script&lang=js&"
import style0 from "./verifyOtpModal.vue?vue&type=style&index=0&id=55960526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55960526",
  null
  
)

component.options.__file = "verifyOtpModal.vue"
export default component.exports